export default __webpack_public_path__ + "static/media/header.ccc86bde.png";